import React, { CSSProperties } from "react";
import { connect } from "react-redux";
import Player from "../Video/VideoPlayer";
import StringHtmlToReact from "../StringHtmlToReact";
import WofButton from "../WofButton";
import { gigyaLoginGiveaway } from "../../actions/auth";

import { generatedGiveAwayId } from "../HowToPlay/HowToPlay";
import "./styles.scss";
import { RootState } from "../../reducers";
import { SendIPAddress } from "../../api/cms";

import GiveawayMastheadImageasBg from "./GiveawayMastheadImageAsBg"
import GiveawayMastheadImageAsImg from "./GiveawayMastheadImageAsImg"

const GiveawayMasthead: React.FC<any> = ({
  giveaway,
  backgroundImage,
  backGroundColor,
  title,
  tuneIn,
  description,
  titleColor,
  tuneInColor,
  videoImage,
  videoUrl,
  howToPlayLinkText,
  howToPlayLinkColor,
  signinLabel,
  showSignIn,
  isLoggedIn,
  logIn,
  mobilebackground,
  giveMastheadClass,
  showSignInButtonOnly,
}) => {
  const bgStyle: CSSProperties = {};
  let hasbgImage = Boolean(backgroundImage);
  const _data = SendIPAddress();
  const useImageOnly = giveMastheadClass.includes('image-only');
  const textBelowImage = giveMastheadClass.includes('text-bellow-image');

  if (hasbgImage) {
    bgStyle.backgroundImage = `url("${backgroundImage}")`;
    bgStyle.backgroundColor = backGroundColor;
  }

  return (
    <>
    {showSignInButtonOnly ?
      <>
      {signinLabel && !isLoggedIn ?
        <div style={{ backgroundColor: backGroundColor }} className="masthead-sign-in-button-only text-center">
          <WofButton id="giveaway_signin_button" onClick={logIn}>
            {signinLabel}
          </WofButton>
        </div>
        : null
      }
      </>
    : (

        <div
          style={{ backgroundColor: backGroundColor }}
          className={
            "giveaway-mh-container " + 
            (videoUrl === "" ? " no-video " : "") +
            giveMastheadClass
          }
        >          
          { useImageOnly ? 
            GiveawayMastheadImageAsImg({backgroundImage, mobilebackground, title})
            : GiveawayMastheadImageasBg({backgroundImage, tuneIn, tuneInColor, mobilebackground}) 
          }
          {videoUrl && (
              <div className="aspect-wrapper">
                <div className="thumbnail-slider aspect-outer">
                  <Player
                    title={""}
                    className="aspect-inner"
                    url={videoUrl}
                    image={videoImage}
                    autoPlay={false}
                    script="https://cdn.jwplayer.com/libraries/niqngNhI.js"
                    id="masthead_video"
                    onFinish={() => {
                      console.log("");
                    }}
                  />
                </div>
              </div>
            )
          }
          { !useImageOnly || textBelowImage ? (
            <div
              className={
                "masthead-title-desc" 
                + (videoUrl === "" && !textBelowImage ? " aspect-wrapper" : "")
                + (textBelowImage ? " text-bellow-image" : "")
              }
            >
              <h1 style={{ color: titleColor }} className="giveaway-mh-title">
                <StringHtmlToReact stringHtml={title} />
              </h1>
              <div className="giveaway-mh-description container">
                <StringHtmlToReact stringHtml={description} />
                {howToPlayLinkText && (
                  <p className="how-to-play-link">
                    <span>
                      <a
                        style={{ color: howToPlayLinkColor }}
                        href={`#${generatedGiveAwayId(giveaway)}`}
                      >
                        {howToPlayLinkText}
                      </a>
                    </span>
                  </p>
                )}
              </div>
            </div>
            )
          : null
          }
          {showSignIn && signinLabel && !isLoggedIn && (
            <div className="ga-mh-sigin-in container">
              {signinLabel ? (
                <WofButton id="giveaway_signin_button" onClick={logIn}>
                  {signinLabel}
                </WofButton>
              ) : null}
            </div>
          )}
        </div>
      )
    }
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  isLoggedIn: state.auth.isLoggedIn,
});

const mapDispatchToProps = (dispatch: any) => ({
  logIn: () => dispatch(gigyaLoginGiveaway()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GiveawayMasthead);
